module.exports = __webpack_public_path__ + "static/img/avatar-bar.1563d5e6.png";